var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSick(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#0a0a29",
    height: "20px",
    width: "20px",
    baseProfile: "tiny",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 256 256",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_4_",
    d: "M119.9,43.8c-11.7-0.9-20.4-11.1-19.5-22.8c0.9-11.7,11.1-20.4,22.8-19.5c11.7,0.9,20.4,11.1,19.5,22.8 C141.8,36,131.6,44.7,119.9,43.8 M125.7,86.3c6.6,1.2,11.6,7.1,11.6,14.1c0,7.9-6.4,14.3-14.3,14.3H76.5c-5,0-9.1-4.1-9.1-9.1 c0-1.2,0.2-2.4,0.7-3.4l5-11.7l55.9-40.1h-26.7C92.2,50.1,85,53.6,80.9,61.7c-2.8,5.4-17.6,38.6-17.6,38.6c-0.7,1.6-1,3.4-1,5.3 c0,7.9,6.4,14.3,14.3,14.3h18.1l-5.4,35.2l-28.2,81.4c-2.4,7.2,1.6,14.9,8.7,17.3c7.2,2.4,14.9-1.5,17.3-8.7l32.4-91.8 c6.3,10.3,18.9,28.7,21,32.1c0.5,5.8,5,56.7,5,56.7c0.7,7.6,7.3,13.1,14.9,12.4c7.5-0.6,13.1-7.3,12.4-14.9l-5.3-59.9 c-0.2-2.1-0.9-4.2-2-6L142.3,136l3.7-47.4c0,0,5.5,18.7,5.9,20.1c1.2,3.9,3.9,6.6,6.6,8.9c1.6,1.3,28.8,19.8,28.8,19.8 c1.5,0.7,2.7,1.3,4.4,1.4c5.3,0.4,9.9-3.5,10.3-8.8c0.3-3.4-1.2-6.5-3.7-8.4c0,0-27.1-18.6-28.2-19.4c-0.9-0.7-1.6-1.9-1.8-2.5 l-10.7-38.6c-1.7-5.8-7.6-10.9-15.1-10.9h-3.2L125.7,86.3z M123,109.4c5,0,9.1-4.1,9.1-9.1c0-4.7-3.6-8.5-8.1-9l-6.6,18.2L123,109.4 z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSick);
export default __webpack_public_path__ + "static/media/sick.ca20fa7e78dcde8d354b3f61878ebd89.svg";
export { ForwardRef as ReactComponent };